import { render, staticRenderFns } from "./GalleryItemSortFilter.vue?vue&type=template&id=2d962cde&scoped=true"
import script from "./GalleryItemSortFilter.vue?vue&type=script&lang=js"
export * from "./GalleryItemSortFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d962cde",
  null
  
)

export default component.exports